document.addEventListener("DOMContentLoaded", function() {
  let images = document.querySelectorAll('.checkout-instructions img')
  const replaceImage = () => {
    images.forEach(element => {
      element.classList.contains('image-visible') ?
      element.classList.remove('image-visible') :
      element.classList.add('image-visible')
    });
  }
   setInterval(replaceImage, 3000);
});


